module.exports = __webpack_public_path__ + "media/Hospital.2a8f8b3f.mp3";